import React, { useState } from "react";
import { connect } from "react-redux";
import { setPersonalSettings } from "redux/index";
import { useTranslation } from "react-i18next";
import makeStyles from "@mui/styles/makeStyles";
import { getPersonalSetting } from "Components/Utilities";
import SomuraSwitchField from "Components/SomuraSwitchField";
import Grid from "@mui/material/Grid";

const useStyles = makeStyles((theme) => ({
  thisForm: {
    padding: "20px 10px 6px 10px",
  },
  hidden: {
    display: "none",
  },
}));

const mapStateToProps = (state) => {
  return {
    loggedUserId: state.loggeduser.LoggedUser.id,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    setPersonalSettings: (values) => dispatch(setPersonalSettings(values)),
  };
};

const YearCalendarForm = ({ setPersonalSettings, loggedUserId, ...props }) => {
  const classes = useStyles();
  const { t } = useTranslation();
  const component = "yearcalendar";
  const [state, setState] = useState({
    autoOpenStats: parseInt(getPersonalSetting(component, "autoOpenStats")),
  });

  const handleChange = (event) => {
    const value = event.target.checked ? 1 : 0;
    setState({ ...state, [event.target.name]: value });
    setPersonalSettings({
      userId: loggedUserId,
      component: component,
      key: event.target.name,
      value: value,
    });
  };

  return (
    <div>
      <div className={classes.thisForm}>
        <Grid container spacing={3}>
          <Grid item xs={12} md={6}>
            <div className={"subLine"}>{t("Vacation statistics")}</div>
            <Grid container spacing={3}>
              <Grid item>
                <SomuraSwitchField
                  name="autoOpenStats"
                  checked={state.autoOpenStats === 1}
                  onChange={handleChange}
                  label={t(
                    "Immediately show vacation statistics when opening calendar"
                  )}
                />
              </Grid>
            </Grid>
          </Grid>
        </Grid>
      </div>
    </div>
  );
};

export default connect(mapStateToProps, mapDispatchToProps)(YearCalendarForm);
